(() => {
  'use strict';

  const configElement = document.getElementById('km-ip-localization-config');
  if (!configElement) return;
  let config;
  try {
    config = JSON.parse(configElement.textContent);
  } catch {
    return;
  }

  const countryLanguages = {
    DE: ['de'], AT: ['de'], LI: ['de'], CH: ['de', 'fr', 'it'],
    FR: ['fr'], BE: ['fr', 'de'], LU: ['fr', 'de'], MC: ['fr'],
    BF: ['fr'], BI: ['fr'], BJ: ['fr'], BL: ['fr'], CD: ['fr'],
    CF: ['fr'], CG: ['fr'], CI: ['fr'], CM: ['fr', 'en'], DJ: ['fr'],
    GA: ['fr'], GF: ['fr'], GN: ['fr'], GP: ['fr'], HT: ['fr'],
    KM: ['fr'], MF: ['fr'], MG: ['fr'], ML: ['fr'], MQ: ['fr'],
    NC: ['fr'], NE: ['fr'], PF: ['fr'], PM: ['fr'], RE: ['fr'],
    RW: ['en', 'fr'], SC: ['en', 'fr'], SN: ['fr'], TD: ['fr'],
    TF: ['fr'], TG: ['fr'], VU: ['en', 'fr'], WF: ['fr'], YT: ['fr'],
    ES: ['es'], AR: ['es'], BO: ['es'], CL: ['es'], CO: ['es'],
    CR: ['es'], CU: ['es'], DO: ['es'], EC: ['es'], GQ: ['es', 'fr'],
    GT: ['es'], HN: ['es'], MX: ['es'], NI: ['es'], PA: ['es'],
    PE: ['es'], PR: ['es', 'en'], PY: ['es'], SV: ['es'], UY: ['es'], VE: ['es'],
    PL: ['pl'], CZ: ['cs'], HU: ['hu'], IT: ['it'], SM: ['it'], VA: ['it'],
    PT: ['pt-pt', 'pt'],
    RU: ['ru'], BY: ['ru'], KZ: ['ru'], KG: ['ru'], JP: ['ja'],
    AG: ['en'], AI: ['en'], AS: ['en'], AU: ['en'], BB: ['en'],
    BM: ['en'], BS: ['en'], BW: ['en'], BZ: ['en'], CA: ['en', 'fr'],
    CC: ['en'], CK: ['en'], CX: ['en'], DM: ['en'], FJ: ['en'],
    FK: ['en'], FM: ['en'], GB: ['en'], GD: ['en'], GG: ['en'],
    GH: ['en'], GI: ['en'], GM: ['en'], GU: ['en'], GY: ['en'],
    HK: ['en'], IE: ['en'], IM: ['en'], IN: ['en'], IO: ['en'],
    JE: ['en'], JM: ['en'], KE: ['en'], KI: ['en'], KN: ['en'],
    KY: ['en'], LC: ['en'], LR: ['en'], LS: ['en'], MH: ['en'],
    MP: ['en'], MS: ['en'], MT: ['en'], MU: ['en', 'fr'], MW: ['en'],
    NA: ['en'], NG: ['en'], NR: ['en'], NU: ['en'], NZ: ['en'],
    PG: ['en'], PH: ['en'], PK: ['en'], PN: ['en'], PW: ['en'],
    SB: ['en'], SD: ['en'], SG: ['en'], SH: ['en'], SL: ['en'],
    SS: ['en'], SZ: ['en'], TC: ['en'], TK: ['en'], TO: ['en'],
    TT: ['en'], TV: ['en'], TZ: ['en'], UG: ['en'], UM: ['en'],
    US: ['en'], VC: ['en'], VG: ['en'], VI: ['en'], WS: ['en'],
    ZA: ['en'], ZM: ['en'], ZW: ['en']
  };
  const preferenceKey = 'km_localization_manual_v2';
  const legacyPreferenceKey = 'km_localization_manual_v1';
  const attemptKey = 'km_localization_attempt_v2';
  const preferenceLifetime = 30 * 24 * 60 * 60 * 1000;
  const attemptCookieLifetime = 30 * 60 * 1000;
  const currencySelector = '[data-testid="localization-currency-code"], header-component .currency-code, drawer-localization-component .currency-code';
  let manualSelection = false;
  let displayCurrency = validCurrency(document.documentElement.dataset.kmDisplayCurrency);
  let receivedCurrencyEvent = Boolean(displayCurrency);
  let currencySyncQueued = false;
  let reconvertQueued = false;

  function readStorage(storage, key) {
    try {
      return window[storage].getItem(key);
    } catch {
      return null;
    }
  }

  function writeStorage(storage, key, value) {
    try {
      window[storage].setItem(key, value);
      return window[storage].getItem(key) === value;
    } catch {
      return false;
    }
  }

  function readCookie(name) {
    try {
      const prefix = `${name}=`;
      const value = document.cookie.split(';').map(item => item.trim()).find(item => item.startsWith(prefix));
      return value ? decodeURIComponent(value.slice(prefix.length)) : null;
    } catch {
      return null;
    }
  }

  function writeCookie(name, value, lifetime) {
    try {
      document.cookie = `${name}=${encodeURIComponent(value)}; Max-Age=${lifetime}; Path=/; SameSite=Lax; Secure`;
      return readCookie(name) === value;
    } catch {
      return false;
    }
  }

  function recentTimestamp(value, lifetime) {
    const timestamp = Number(value);
    const age = Date.now() - timestamp;
    return timestamp > 0 && age >= 0 && age < lifetime;
  }

  function hasManualPreference() {
    return manualSelection ||
      recentTimestamp(readStorage('localStorage', preferenceKey), preferenceLifetime) ||
      recentTimestamp(readCookie(preferenceKey), preferenceLifetime) ||
      recentTimestamp(readStorage('localStorage', legacyPreferenceKey), preferenceLifetime) ||
      readCookie(legacyPreferenceKey) === '1';
  }

  function rememberManualSelection() {
    manualSelection = true;
    const timestamp = String(Date.now());
    writeStorage('localStorage', preferenceKey, timestamp);
    writeCookie(preferenceKey, timestamp, preferenceLifetime / 1000);
  }

  function readAttempts(storageValue) {
    try {
      const value = JSON.parse(storageValue || '{}');
      return value && typeof value === 'object' && !Array.isArray(value) ? value : {};
    } catch {
      return {};
    }
  }

  function hasAttempt(target) {
    const stored = readAttempts(readStorage('sessionStorage', attemptKey));
    const cookie = readAttempts(readCookie(attemptKey));
    return Number(stored[target]) > 0 || recentTimestamp(cookie[target], attemptCookieLifetime);
  }

  function rememberAttempt(target) {
    const now = Date.now();
    const stored = readAttempts(readStorage('sessionStorage', attemptKey));
    stored[target] = now;
    const storedSafely = writeStorage('sessionStorage', attemptKey, JSON.stringify(stored));
    const cookie = readAttempts(readCookie(attemptKey));
    const recent = Object.fromEntries(Object.entries(cookie).filter(([, timestamp]) => recentTimestamp(timestamp, attemptCookieLifetime)));
    recent[target] = now;
    const cookieSafely = writeCookie(attemptKey, JSON.stringify(recent), attemptCookieLifetime / 1000);
    return storedSafely || cookieSafely;
  }

  function validCurrency(value) {
    const currency = typeof value === 'string' ? value.trim().toUpperCase() : '';
    return /^[A-Z]{3}$/.test(currency) ? currency : '';
  }

  function syncCurrency() {
    const converted = document.querySelector('.money[bucks-currency]');
    const currency = receivedCurrencyEvent ? displayCurrency : validCurrency(converted?.getAttribute('bucks-currency')) || displayCurrency;
    if (!currency) return;
    displayCurrency = currency;
    document.documentElement.dataset.kmDisplayCurrency = currency;
    document.querySelectorAll(currencySelector).forEach(element => {
      if (element.textContent.trim() !== currency) element.textContent = currency;
    });
  }

  function scheduleCurrencySync() {
    if (currencySyncQueued) return;
    currencySyncQueued = true;
    window.requestAnimationFrame(() => {
      currencySyncQueued = false;
      syncCurrency();
    });
  }

  function scheduleReconvert() {
    if (reconvertQueued) return;
    reconvertQueued = true;
    window.requestAnimationFrame(() => {
      reconvertQueued = false;
      try {
        if (typeof window.bucksCC?.reConvert === 'function') window.bucksCC.reConvert();
      } catch {
        return;
      } finally {
        scheduleCurrencySync();
      }
    });
  }

  document.addEventListener('BUCKS_SELECTED_CURRENCY', event => {
    const currency = validCurrency(event.detail);
    if (!currency) return;
    displayCurrency = currency;
    receivedCurrencyEvent = true;
    document.documentElement.dataset.kmDisplayCurrency = currency;
    scheduleCurrencySync();
  });

  document.addEventListener('change', event => {
    if (event.isTrusted && event.target instanceof Element && event.target.matches('localization-form-component [name="language_code"], localization-form-component [name="country_code"]')) {
      rememberManualSelection();
    }
  }, true);

  document.addEventListener('click', event => {
    if (event.isTrusted && event.target instanceof Element && event.target.closest('localization-form-component [data-value]')) {
      rememberManualSelection();
    }
  }, true);

  document.addEventListener('keydown', event => {
    if (event.isTrusted && event.key === 'Enter' && event.target instanceof Element) {
      const wrapper = event.target.closest('localization-form-component .country-selector-form__wrapper');
      if (wrapper?.querySelector('[data-value][aria-selected="true"]')) rememberManualSelection();
    }
  }, true);

  for (const eventName of ['shopify:section:load', 'variant:update', 'cart:update', 'discount:update', 'filter:update']) {
    document.addEventListener(eventName, scheduleReconvert);
  }

  function normalizedLanguage(value) {
    return typeof value === 'string' ? value.trim().toLowerCase().replace(/_/g, '-') : '';
  }

  function hasExplicitLanguagePath() {
    const segment = normalizedLanguage((window.location.pathname || '/').split('/')[1]);
    if (!/^[a-z]{2,3}(?:-[a-z0-9]{2,8})*$/.test(segment)) return false;
    return config.languages.map(normalizedLanguage).some(language =>
      segment === language || segment === language.split('-')[0] || segment.startsWith(`${language}-`)
    );
  }

  function chooseLanguage(country) {
    const published = config.languages.map(normalizedLanguage);
    const localLanguages = config.countryLanguages?.[country];
    const available = Array.isArray(localLanguages) ? localLanguages.map(normalizedLanguage).filter(language => published.includes(language)) : published;
    if (!available.length) return '';

    function availableLanguage(candidate) {
      const language = normalizedLanguage(candidate);
      if (available.includes(language)) return language;
      if (language.includes('-')) return '';
      if (language === 'pt') return available.includes('pt-pt') ? 'pt-pt' : '';
      const regionalLanguage = `${language}-${country.toLowerCase()}`;
      if (available.includes(regionalLanguage)) return regionalLanguage;
      const variants = available.filter(value => value.split('-')[0] === language);
      return variants.length === 1 ? variants[0] : '';
    }

    const candidates = countryLanguages[country] || [normalizedLanguage(config.defaultLanguage)];
    const supportedCandidates = [...new Set(candidates.map(availableLanguage).filter(Boolean))];
    if (supportedCandidates.length > 1) {
      const browserLanguages = Array.isArray(navigator.languages) ? navigator.languages : [navigator.language];
      for (const browserLanguage of browserLanguages) {
        const language = normalizedLanguage(browserLanguage);
        if (supportedCandidates.includes(language)) return language;
        const matchingLanguage = supportedCandidates.find(value => value.split('-')[0] === language.split('-')[0]);
        if (matchingLanguage) return matchingLanguage;
      }
    }
    if (supportedCandidates.length) return supportedCandidates[0];

    const fallback = availableLanguage(config.defaultLanguage);
    if (country === 'PT') {
      // Portugal must never silently select Brazilian Portuguese.
      return fallback && fallback.split('-')[0] !== 'pt' ? fallback : available.find(language => language.split('-')[0] !== 'pt') || '';
    }
    return fallback || available[0];
  }

  function currentReturnPath() {
    let path = window.location.pathname || '/';
    const root = typeof config.rootUrl === 'string' ? config.rootUrl.replace(/\/$/, '') : '';
    if (root && (path === root || path.startsWith(`${root}/`))) path = path.slice(root.length) || '/';
    const segments = path.split('/');
    if (config.languages.map(normalizedLanguage).includes(normalizedLanguage(segments[1]))) segments.splice(1, 1);
    path = segments.join('/') || '/';
    return path + window.location.search + window.location.hash;
  }

  function submitLocalization(country, language) {
    const form = document.createElement('form');
    form.method = 'POST';
    form.action = '/localization';
    form.hidden = true;
    for (const [name, value] of Object.entries({
      form_type: 'localization', utf8: '✓', _method: 'PUT',
      country_code: country, language_code: config.languages.find(value => normalizedLanguage(value) === language) || language, return_to: currentReturnPath()
    })) {
      const input = document.createElement('input');
      input.type = 'hidden';
      input.name = name;
      input.value = value;
      form.appendChild(input);
    }
    document.body.appendChild(form);
    form.submit();
  }

  async function localizeVisit() {
    if (!Array.isArray(config.languages) || !Array.isArray(config.countries) || hasManualPreference() || hasExplicitLanguagePath()) return;
    if (/bot|crawler|spider|crawling|lighthouse/i.test(navigator.userAgent)) return;
    if (/^\/(?:checkout|checkouts|challenge|account|localization)(?:\/|$)/.test(currentReturnPath().split(/[?#]/)[0])) return;
    const controller = new AbortController();
    const timeout = window.setTimeout(() => controller.abort(), 3500);
    try {
      const response = await fetch('/browsing_context_suggestions.json?country[enabled]=true&language[enabled]=true', {
        credentials: 'same-origin', signal: controller.signal, headers: { Accept: 'application/json' }
      });
      if (!response.ok) return;
      const result = await response.json();
      const country = typeof result.detected_values?.country?.handle === 'string' ? result.detected_values.country.handle.toUpperCase() : '';
      if (!/^[A-Z]{2}$/.test(country) || !config.countries.includes(country) || hasManualPreference()) return;
      const language = chooseLanguage(country);
      if (!language || (country === config.country && language === normalizedLanguage(config.language))) return;
      const target = `${country}|${language}`;
      if (hasAttempt(target) || !rememberAttempt(target)) return;
      submitLocalization(country, language);
    } catch {
      return;
    } finally {
      window.clearTimeout(timeout);
    }
  }

  function start() {
    syncCurrency();
    const observer = new MutationObserver(records => {
      for (const record of records) {
        if (record.type === 'attributes') {
          const currency = validCurrency(record.target.getAttribute('bucks-currency'));
          if (currency && !receivedCurrencyEvent) displayCurrency = currency;
          scheduleCurrencySync();
          return;
        }
        for (const node of record.addedNodes) {
          if (!(node instanceof Element)) continue;
          if (node.matches(currencySelector) || node.querySelector(currencySelector) || node.matches('.money[bucks-currency]') || node.querySelector('.money[bucks-currency]')) {
            scheduleCurrencySync();
            return;
          }
        }
      }
    });
    observer.observe(document.body, { childList: true, subtree: true, attributes: true, attributeFilter: ['bucks-currency'] });
    localizeVisit();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
  else start();
})();

